import { generatePath } from 'react-router'

import { useAddressStore } from '@features/shipping-methods'

import { ProductCarousel } from '@widgets/product-carousel'


import { URL_PAGE_PRODUCT_GROUP } from '@shared/contants'
import { Product, useAllProductsPreviewCardQuery, useSingleProductGroupQuery } from '@shared/generated'




type ProductsGroupCarouselProps = {
  id: string
}

export default function ProductsGroupCarousel ({
  id
}: ProductsGroupCarouselProps) {
  const { shopId } = useAddressStore()
  
  const { data, loading } = useSingleProductGroupQuery({
    variables: {
      id,
      shop_id: shopId,
    }
  })

  const { data: productsData, loading: loadingProducts } = useAllProductsPreviewCardQuery({
    variables: {
      shopId,
      pager: {
        limit: 20
      },
      filter: {
        fields: [ 'productGroupIds' ],
        op: 'contains',
        value: [ id ]
      }
    }
  })

  return (
    <>
      {data && (
        <ProductCarousel
          link={generatePath(URL_PAGE_PRODUCT_GROUP, {
            productGroupId: data.singleProductGroup?.id as string
          })}
          title={data.singleProductGroup?.label ?? ''}
          products={productsData?.allProducts?.edges as Product[] ?? []}
          loading={loading || loadingProducts}
          listName={`Product Group: ${data.singleProductGroup?.label ?? ''}`}
          listId={data.singleProductGroup?.id ?? undefined}
        />
      )}
    </>
  )
};
